import createActions from 'utils/redux/createActions'

export default createActions([
	'REPAIRMEN_FILTER_UPDATED'
  , 'CLEAR_REPAIRMEN_FILTERS'
])



// WEBPACK FOOTER //
// ./src/actions/repairmenFilters.js